import { Injectable } from '@angular/core';
import { getEndpoint } from 'src/app/core/services/functions.service';
import { RequestsService } from 'src/app/core/services/requests.service';

@Injectable({
  providedIn: 'root',
})
export class VisorService {
  constructor(private _RequestsService: RequestsService) { }

  URL_BASE = getEndpoint('VISOR_ENDPOINT');
  URL_BASE2 = getEndpoint('WEB_LOGIC_API');

  documents_types = async () => {
    try {
      let result = this._RequestsService.get(
        `${this.URL_BASE2}/v1/JA/causal/TQ`
      );
      return (result);
    } catch (error) {
      return (error);
    }
  };
  modo_c = async (doc, n_ide) => {
    try {
      let id: any = await this.internal_id(n_ide);
      let result = await this._RequestsService.get(
        `${this.URL_BASE}/v1/JA/client/${n_ide}?internal_id=${id.data.internal_id}&origen=TARJPN&agency=C1&vendedor=TJWEB&tipo_doc=${doc}&canal_venta=distancia&usuario=TJWEB&programa=TARJPN`
      );
      result.data.internal_id = id.data.internal_id;
      return result
    } catch (error) {
      return error;
    }
  };
  internal_id = async (cedula) => {
    try {
      let result = await this._RequestsService.postLikeJSON(
        `${this.URL_BASE}/v1/JA/client?origin=TARJPN&source=TARJPN&field=identification&value=${cedula}`,
        {}
      );
      return (result);
    } catch (error) {
      return (error);
    }
  };

  modo_e = async (body, n_ide) => {
    try {
      let result = await this._RequestsService.postLikeJSON(
        `${this.URL_BASE}/v1/JA/cliente/${n_ide}`,
        body
      );
      return (result);
    } catch (error) {
      return (error);
    }
  };
}
